import React, { useEffect, useState } from "react";
import { ButtonOutlined } from "../../../../components/button/ButtonCustoms";
import ModalCustom from "../../../../components/modal/ModalCustom";
import FormComponent from "../../../../components/gernerateForm/FormComponent";
import formGeneratePaymentApplication from "./dataFormGenerate.data";
import CardSlipPayment from "../components/card-slip-payment/CardSlipPayment";
import { useTranslation } from "react-i18next";

type Props = {
  isOpenModal: boolean;
  setIsOpenModal: (isOpen: boolean) => void; // Accepts a boolean argument
  data?: any;
};

const ModalTermFeesDetail: React.FC<Props> = (props: Props) => {
  const { t } = useTranslation();
  const { isOpenModal, setIsOpenModal, data } = props;

  const [dataModal, setDataModal] = useState<any>({
    payment: {
      term: "",
      year: "",
      payment_date: "",
      payment_time: "",
      currency: "",
      amount: 0,
      payment_type: "",
      file_path: "",
    },
  });

  useEffect(() => {
    if (data) {
      setDataModal({
        payment: {
          term: data?.stp_term ?? "",
          year: data?.stp_year ?? "",
          payment_date: data.stp_payment_date ?? "",
          payment_time: data.stp_payment_time ?? "",
          currency: data?.stp_payment_currency
            ? data?.stp_payment_currency.toUpperCase()
            : "",
          amount: data.stp_payment_amount ?? 0,
          payment_type: data.stp_payment_type ?? "",
          file_path: data.stp_file_path ?? "",
        },
      });
    }
  }, [data]);

  return (
    <ModalCustom
      title={t("หลักฐานการชำระค่าเทอม")}
      subTitle={`${t("ปีการศึกษา :")} ${dataModal.payment.year}  ${t("ภาคเรียนที่ :")} ${dataModal.payment.term}`}
      open={isOpenModal}
      onClose={() => {
        setIsOpenModal(false);
      }}
      component={
        <section className="grid grid-cols-12 gap-y-6">
          <article className="col-span-12 flex items-center justify-center">
            {t("ผู้ตรวจสอบ :")}{" "}
            {/* i18n-ignore (hard-coded sample name) */}
            นางมาริสา มากดีดก
          </article>

          <article className="col-span-12 flex items-center justify-center">
            <FormComponent
              formGenerate={formGeneratePaymentApplication}
              inputValue={dataModal}
              setInputValue={setDataModal}
              handleCheckValid={false}
              isCanEdit={false}
              permission={"admin"}
            />
          </article>
          
          <article className="col-span-12 flex items-center justify-center gap-4 my-4">
            <CardSlipPayment
              file_path={dataModal.payment.file_path ?? null}
              onDownloadFile={() => {
                // if (student_id && id_student_register_payment) {
                //   handleDownloadFile(student_id, id_student_register_payment);
                // }
              }}
            />
          </article>

          <article className="col-span-12 flex items-center justify-center gap-4 my-4">
            <ButtonOutlined
              onClick={() => {
                setIsOpenModal(false);
              }}
              mode="del"
              buttonName={t("ย้อนกลับ")}
              btnProps={{
                width: "100px",
              }}
            />
          </article>
        </section>
      }
    />
  );
};

export default ModalTermFeesDetail;
